module.exports = __webpack_public_path__ + "img/banner52.c891b67e.png";